// @flow
import * as React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/card.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/divider.css'
import { hot } from 'react-hot-loader'
import './styles.scss'
import { TypescriptComponent } from 'components/typescriptExample'
import Masthead from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import ThemeSwitch from '@ta-interaktiv/react-theme-switch'
import { Waypoint } from 'react-waypoint'


// TODO Set the correct article ID here
const ARTICLE_ID = '10368848'

class AppComponent extends React.Component<Props> {

  constructor(props) {
    super(props)
  }

  render() {
    return (
    <div className='index'>

      <Masthead inverted articleId={ARTICLE_ID} />
      <ThemeSwitch />

      <header className='ui vertical fitted segment'>
        <div className='ui container'>
          <h1 className='ui header inverted' style={{ marginBottom: 0 }}>
            Wie sie spinnen – Faden für Faden
          </h1>

          <Waypoint
            scrollableAncestor={window}
            onLeave={({ previousPosition, currentPosition }) => {
              const name = 'startReading'
              if (
                previousPosition === Waypoint.inside &&
                currentPosition === Waypoint.above
              ) {
                window.dataLayer = window.dataLayer || []
                if (!window.dataLayer.find(element => element.event === name)) {
                  window.dataLayer.push({ event: name })
                }
              }
            }}
          />

          <h2 className='ui header inverted' style={{ marginTop: 0 }}>
            <div className='small sub header'>
              Spinnen mussten Millionen Jahre üben, um solch komplexe Netze
              konstruieren zu können. Wir zeigen in zwölf Animationen, wie
              raffiniert sie entstehen.
            </div>
          </h2>
        </div>
      </header>


      {/* TODO And probably remove the following segment and replace it with
       your own content */}
      <div className='ui vertical segment'>
        <div className='ui container'>

            <div className="ui stackable four column grid">
              <div className="ten wide column">
                <img
                 className='ui fluid image'
                 src={require('./imgs/net_theridiosoma_infinity.gif')}
                />
              </div>
              <div className="six wide column textBox">
                <img
                 className='ui fluid image spyder'
                 src={require('./imgs/3-THERIDIOSOMA-a7beef76fb0d9a28.gif')}
                />
                <h4>Theridiosoma</h4>
                <div className="ui divider"></div>
                <div>
                  <p>Spinnen der Gattung Theridiosoma ergänzen die gewöhnlichen
                  Radnetze um einen Steinschleuder-Mechanismus. An einem zentral befestigten
                  Faden ziehen sie das Netz zu einer Seite, sodass sich ein Kegel ergibt.
                  Fliegt Beute ins Netz, kappen die Spinnen den Haltefaden und das Netz
                  schießt um die Beute. Die einzige in Europa vorkommende Art ist die
                  Zwergradnetzspinne.</p>
                </div>
              </div>
            </div>

            <div className="ui stackable four column grid">
              <div className="ten wide column">
                <img
                 className='ui fluid image'
                 src={require('./imgs/net_scoloderus_infinity.gif')}
                />
              </div>
              <div className="six wide column textBox">
                <img
                 className='ui fluid image spyder'
                 src={require('./imgs/2-SCOLODERUS-5d0853f8f6520e0b.gif')}
                />
                <h4>Scoloderus</h4>
                <div className="ui divider"></div>
                <div>
                  <p>Scoloderus-Spinnen ergänzen ihr Radnetz um eine Art Leiter,
                  die sie darüberweben. Das hilft ihnen, auch größere Insekten zu
                  fangen, die sich sonst befreien könnten, bevor die Spinne sie schnappt.
                  Fliegen etwa größere Motten gegen die Leiter, purzeln sie beim Versuch
                  sich zu entwirren Stufe um Stufe hinab bis ins Netz. Dort ist dann
                  die Spinne zur Stelle.</p>
                </div>
              </div>
            </div>

            <Waypoint
              scrollableAncestor={window}
              onEnter={event => {
                if (
                  event.previousPosition === Waypoint.below &&
                  event.currentPosition === Waypoint.inside
                ) {
                  window.dataLayer = window.dataLayer || []
                  window.dataLayer.push({
                    event: '25ContentRead'
                  })
                }
              }}
            />

            <div className="ui stackable four column grid">
              <div className="ten wide column">
                <img
                 className='ui fluid image'
                 src={require('./imgs/net_hyptiotes_infinity.gif')}
                />
              </div>
              <div className="six wide column textBox">
                <img
                 className='ui fluid image spyder'
                 src={require('./imgs/4-HYPTIOTES-656681d090bbb886.gif')}
                />
                <h4>Hyptiotes</h4>
                <div className="ui divider"></div>
                <div>
                  <p>Diese Spinnen haben das Radnetz stark eingekürzt. Sie weben
                  nur noch drei Netz-Sektoren, die sie oft zwischen den unteren
                  Zweigen von Nadelbäumen spannen. Den Haltefaden an der Spitze
                  des Netzes hält die Spinne mit ihren Vorderbeinen, sie selbst
                  baumelt ebenfalls an einem Faden. Fliegt ein Insekt ins Netz,
                  seilt sie sich ab, und das Netz stürzt über der Beute zusammen.</p>
                </div>
              </div>
            </div>

            <div className="ui stackable four column grid">
              <div className="ten wide column">
                <img
                 className='ui fluid image'
                 src={require('./imgs/net_achaearanea_infinity.gif')}
                />
              </div>
              <div className="six wide column textBox">
                <img
                 className='ui fluid image spyder'
                 src={require('./imgs/5-ACHAEARANEA-f5ba0c2a2fcb26a8.gif')}
                />
                <h4>Achaearanea</h4>
                <div className="ui divider"></div>
                <div>
                  <p>Die Netze der Achaearanea-Spinnen bestehen aus wahllos gespannten
                  Fäden. Die Netze sind Weiterentwicklungen des Rades, doch anscheinend
                  hielten die Spinnen Symmetrie für überbewertet. In der Mitte wird das
                  Netz dichter, die Fäden benetzen die Spinnen mit einer klebrigen
                  Substanz. Hierzulande sieht man vor allem die Netze der Gewächshausspinne.</p>
                </div>
              </div>
            </div>

            <div className="ui stackable four column grid">
              <div className="ten wide column">
                <img
                 className='ui fluid image'
                 src={require('./imgs/net_meta_infinity.gif')}
                />
              </div>
              <div className="six wide column textBox">
                <img
                 className='ui fluid image spyder'
                 src={require('./imgs/6-META-0cb17bc9223d3d21.gif')}
                />
                <h4>Meta</h4>
                <div className="ui divider"></div>
                <div>
                  <p>Spinnen der Gattung Meta weben ein Radnetz, wobei sie die
                  Spirale nicht bis ganz zur Mitte fertig weben. Hin und wieder
                  verlassen sie ihr Netz und jagen Insekten auch auf naheliegenden
                  Felswänden. In Europa ist besonders die Große Höhlenspinne
                  verbreitet – in Höhlen. Die Weibchen benutzen die Seide auch,
                  um ihre in Kokons verpackten Eier an einem Faden aufzuhängen.</p>
                </div>
              </div>
            </div>

            <div className="ui stackable four column grid">
              <div className="ten wide column">
                <img
                 className='ui fluid image'
                 src={require('./imgs/net_araneus_infinity.gif')}
                />
              </div>
              <div className="six wide column textBox">
                <img
                 className='ui fluid image spyder'
                 src={require('./imgs/7-ARANEUS-4a2883e31d5854fd.gif')}
                />
                <h4>Araneus</h4>
                <div className="ui divider"></div>
                <div>
                  <p>Beim Weben von Radnetzen macht den Araneus-Spinnen (Kreuzspinnen)
                  kein anderer Achtbeiner etwas vor. Einige Arten spinnen ihr klassisches
                  Rad in weniger als einer Stunde und produzieren dazu etwa 20 Meter Faden.
                  Erst bauen sie den Rahmen, dann die Stützfäden zur Mitte und schließlich
                  die Spirale. Weibchen werden bis zu vier Mal so groß wie Männchen.</p>
                </div>
              </div>
            </div>

            <Waypoint
              scrollableAncestor={window}
              onEnter={event => {
                if (
                  event.previousPosition === Waypoint.below &&
                  event.currentPosition === Waypoint.inside
                ) {
                  window.dataLayer = window.dataLayer || []
                  window.dataLayer.push({
                    event: '50ContentRead'
                  })
                }
              }}
            />

            <div className="ui stackable four column grid">
              <div className="ten wide column">
                <img
                 className='ui fluid image'
                 src={require('./imgs/net_uloborus_infinity.gif')}
                />
              </div>
              <div className="six wide column textBox">
                <img
                 className='ui fluid image spyder'
                 src={require('./imgs/8-ULOBORUS-d53617fdeae5433d.gif')}
                />
                <h4>Uloborus</h4>
                <div className="ui divider"></div>
                <div>
                  <p>Die Radnetze der Uloborus-Spinnen (Federfußspinnen) sind mit
                  bis zu 30 Zentimetern eher klein. Damit Insekten im Netz hängen
                  bleiben, setzen die Spinnen nicht auf klebrige Fäden, sondern
                  kräuseln kleinere Fäden um die dickeren Netzfäden. Darin verfangen
                  sich Insekten. Einige Arten weben Muster in ihr Netz. Warum ist unklar,
                  vielleicht schrecken sie damit Feinde ab.</p>
                </div>
              </div>
            </div>

            <div className="ui stackable four column grid">
              <div className="ten wide column">
                <img
                 className='ui fluid image'
                 src={require('./imgs/net_linyphia_infinity.gif')}
                />
              </div>
              <div className="six wide column textBox">
                <img
                 className='ui fluid image spyder'
                 src={require('./imgs/9-LINYPHIA-8ff1646fe7244bec.gif')}
                />
                <h4>Linyphia</h4>
                <div className="ui divider"></div>
                <div>
                  <p>Diese Spinnen weben ein dichtes Gespinst aus Fäden, mit dem
                  sie teils ganze Gräser überziehen. Einzelne Fäden spinnt sie
                  über dem Netz zu höher gelegenen Punkten. Sie selbst krabbelt
                  an der Unterseite des Netzes. Fliegt ein Insekt gegen einen der
                  einzelnen Fäden und stürzt auf das dichte Netz, beißt die Spinne
                  von unten zu. Nach dem Essen beseitigt sie die Bissschäden.</p>
                </div>
              </div>
            </div>

            <div className="ui stackable four column grid">
              <div className="ten wide column">
                <img
                 className='ui fluid image'
                 src={require('./imgs/net_dictyna_infinity.gif')}
                />
              </div>
              <div className="six wide column textBox">
                <img
                 className='ui fluid image spyder'
                 src={require('./imgs/10-DICTYNA-f89fbafd8d853e70.gif')}
                />
                <h4>Dictyna</h4>
                <div className="ui divider"></div>
                <div>
                  <p>Spinnen der Gattung Dictyna weben unregelmäßige Netze. Das
                  tun sie in der Nähe des Bodens, also auf niedrigen Pflanzen oder
                  Bäumen, manchmal auch direkt auf dem Boden zwischen ein paar Grashalmen.
                  Auch diese Spinnen benutzen keinen Leim, sondern kräuseln ihre Fäden.
                  Insekten, die dagegen laufen oder fliegen, verheddern sich dann mit
                  ihren Härchen darin.</p>
                </div>
              </div>
            </div>

            <div className="ui stackable four column grid">
              <div className="ten wide column">
                <img
                 className='ui fluid image'
                 src={require('./imgs/net_stegodyphus_infinity.gif')}
                />
              </div>
              <div className="six wide column textBox">
                <img
                 className='ui fluid image spyder'
                 src={require('./imgs/1-STEGODYPHUS-13dc7daa03d16cc5.gif')}
                />
                <h4>Stegodyphus</h4>
                <div className="ui divider"></div>
                <div>
                  <p>Stegodyphus-Spinnen weben wollig gekräuselte Netze. Für
                  die Radform scheinen sie sich dabei nicht besonders zu interessieren.
                  Einige Arten leben in sozialen Verbünden, sie wohnen und jagen gemeinsam.
                  Zudem gibt es Arten, die mit in die Luft geschossenen und vom Wind getragenen
                  Fäden Hunderte Kilometer weit fliegen können – dem sogenannten Ballooning.</p>
                </div>
              </div>
            </div>

            <div className="ui stackable four column grid">
              <div className="ten wide column">
                <img
                 className='ui fluid image'
                 src={require('./imgs/net_agelena_infinity.gif')}
                />
              </div>
              <div className="six wide column textBox">
                <img
                 className='ui fluid image spyder'
                 src={require('./imgs/0-ERESUS-5e30e82d7ae354e9.gif')}
                />
                <h4>Agelena</h4>
                <div className="ui divider"></div>
                <div>
                  <p>Die Spinnen aus der Gattung Agelena zählen zur Familie der
                  sogenannten Trichternetzspinnen und weben dichte, nicht besonders
                  klebrige Netze am Boden oder knapp darüber. An einer Stelle laufen
                  die Netze dann zu einem Trichter zusammen, in dem die Spinne sitzt
                  und auf Beute lauert. Der Trichter ist hinten offen, so kann die
                  Spinne bei Gefahr entkommen.</p>
                </div>
              </div>
            </div>

            <div className="ui stackable four column grid">
              <div className="ten wide column">
                <img
                 className='ui fluid image'
                 src={require('./imgs/net_cteniza_infinity.gif')}
                />
              </div>
              <div className="six wide column textBox">
                <img
                 className='ui fluid image spyder'
                 src={require('./imgs/11-CTENIZIDS-c2cf2fa27ce6cbee.gif')}
                />
                <h4>Cteniza</h4>
                <div className="ui divider"></div>
                <div>
                  <p>Cteniza-Spinnen gehören zu den sogenannten vogelspinnenartigen
                  Spinnen. Sie graben sich ein Loch in die Erde und bauen aus Seide,
                  Erde und sonstiger Vegetation einen korkähnlichen Deckel für ihr
                  Versteck. Aus dem Loch legen sie dann ein paar Fäden, um durch
                  Vibration zu erkennen, wenn Beute naht. Bis es so weit ist, warten
                  sie an der Unterseite des Deckels.</p>
                </div>
              </div>
            </div>

        </div>
        <Waypoint
          scrollableAncestor={window}
          onEnter={event => {
            if (
              event.previousPosition === Waypoint.below &&
              event.currentPosition === Waypoint.inside
            ) {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'contentBottom'
              })
            }
          }}
        />

      </div>

      {/* TODO Add your credits in this component */}
      <Footer articleId={ARTICLE_ID} credits={[['Digitale Umsetzung', 'Patrick Vögeli'],['Text', 'Jan  Schwenkenbecher'],['Illustrationen', 'Stefan Dimitrov']]} starColor={'blue'}/>

      <Waypoint
        scrollableAncestor={window}
        onEnter={event => {
          if (
            event.previousPosition === Waypoint.below &&
            event.currentPosition === Waypoint.inside
          ) {
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
              event: 'pageBottom'
            })
          }
        }}
      />

    </div>
  )
}
}

export default hot(module)(AppComponent)
